import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RefreshIcon } from "../icons";
import { CUSTOM_PERIOD, PERIODS } from "./activityUtils";

// Activity-wise controls shown on the right of the tabs bar: Period (+ date range when
// Custom) and a manual refresh.
const ActivityToolbar = ({ period, dateRange, onPeriodChange, onDateRangeChange, onRefresh, refreshing, disabled }) => (
  <div className="activity-toolbar">
    <div className="activity-toolbar-right">
      <label className="activity-period">
        <span>Period</span>
        <select value={period} onChange={(e) => onPeriodChange(e.target.value)} aria-label="Activity period">
          {PERIODS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
        </select>
      </label>
      {period === CUSTOM_PERIOD && (
        <div className="activity-date-range">
          <DatePicker
            selectsRange
            startDate={dateRange[0]}
            endDate={dateRange[1]}
            onChange={onDateRangeChange}
            isClearable={true}
            maxDate={new Date()}
            dateFormat="dd MMM"
            className="form-control date-range-picker"
            placeholderText="Select date range"
            calendarClassName="activity-datepicker"
            popperClassName="activity-datepicker-popper"
            popperPlacement="bottom-end"
            portalId="activity-datepicker-portal"
          />
        </div>
      )}
      <button type="button" className="tabs-refresh-btn" onClick={onRefresh} disabled={disabled || refreshing} title="Refresh" aria-label="Refresh">
        <span className={refreshing ? "activity-spin" : undefined}><RefreshIcon size={15} /></span>
      </button>
    </div>
  </div>
);

export default ActivityToolbar;
